/* eslint-disable @typescript-eslint/no-explicit-any */
import moment from 'moment';
import { commonServices } from '../../api/services/commonServices';
import $ from 'jquery';
import { notificationService } from '../../api/services/notificationService';

export const weather_api_key = '4350fe16c1b641a9c0e10b16851c7fb7';
export const temp_token_for_login: any = localStorage.getItem('bearer_token');
const currentDate = new Date();
export const currentDay = currentDate.toLocaleString('en-us', {
  weekday: 'long',
});
export const currentTime = currentDate.toLocaleTimeString('en-US', {
  hour: '2-digit',
  minute: '2-digit',
});
export const Weather_API_URL =
  'https://api.openweathermap.org/data/2.5/weather';

export const personalDetails_Modal_KeyValues = {
  perosnalInformation: 'personal_information',
  job_information: 'job_information',
  emergency_contact: 'emergency_contact',
  bank_details: 'bank_details',
  skills_details: 'skills_details',
  about_me: 'about_me',
};

export const allMaritalStatus = [
  { key: 'Single', value: 'Single' },
  { key: 'Married', value: 'Married' },
];

export const allGenders = [
  { key: 'Male', value: 'Male' },
  { key: 'Female', value: 'Female' },
  { key: 'Other', value: 'Other' },
];

export const getUserProfilePic: any = async (userId: number) => {
  const response: any = await commonServices.getFullPathProfilePic(userId);
  const profile_pic = response?.data?.profile_pic;
  return profile_pic;
};

export const getEmpTicketTypes: any = async (id: number) => {
  const response: any = await commonServices.getEmpTicketTypes(id);
  const data = response?.data;
  return data;
};

export const getPreviousYears = () => {
  /*  Function will return current year and last 2 years*/
  const current_year: any = moment(new Date()).format('YYYY');

  let year: any = Number(current_year);
  const years: any = [];
  for (let i = 0; i < 6; i++) {
    const obj = { id: year, label: year, color: '#7C0E6F' };

    years.push(obj);
    year--;
  }
  return years;
};

export const getPreviousYearsAndMonth = (t: any) => {
  /*  Function will return  current month and last 2 months */

  const arRet = [];

  for (let n = 0; n < 3; n++) {
    const _dataId = moment().subtract(n, 'months').format('M YYYY');
    const _dataLabel = date_Format4(
      moment().subtract(n, 'months').format('MMM YYYY'),
      t,
    );

    arRet.push({ id: _dataId, label: _dataLabel, color: '#7C0E6F' });
  }
  return arRet;
};

export const getNextYearsAndMonth_ForShiftRoaster = (trans: any) => {
  /*  Function will return  current month and next 2 months */

  const arRet = [];

  for (let n = 0; n < 3; n++) {
    const _startDate = moment()
      .add(n, 'months')
      .startOf('month')
      .format('YYYY-MM-DD');
    const _lastDate = moment()
      .add(n, 'months')
      .endOf('month')
      .format('YYYY-MM-DD');

    const _date: any = moment().add(n, 'months');
    const _dataLabel: any = date_Format4(_date?._d, trans);

    arRet.push({
      from_date: _startDate,
      to_date: _lastDate,
      label: _dataLabel,
      color: '#7C0E6F',
    });
  }
  return arRet;
};

export function validateEmail(email: string) {
  return String(email)
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    );
}

export const getUpdateReadAt = async (
  id: any,
  table: string,
  empID: number,
) => {
  let data;
  await notificationService
    .updatereadat(id, table, empID)
    .then((response) => {
      data = response.data;
    })
    .catch((err) => {
      data = err;
    });
  return data;
};

export function validateMobileNumberWithCountryCode(phone: any) {
  const regmm = '^([0|+[0-9]{1,3})?([0-9]{10})$';
  const regmob = new RegExp(regmm);
  if (regmob.test(phone)) {
    return true;
  } else {
    return false;
  }
}

export async function logoutService(user_session_id: any) {
  return await commonServices.logout(user_session_id);
}
export function getAmount(amount: any) {
  if (amount) {
    const number = Number(amount);
    const roundedNumber: any = Math.floor(number * 100) / 100;
    const _finalNumber = parseFloat(roundedNumber).toFixed(2);

    const _amount = Number(_finalNumber);
    return _amount.toLocaleString('en-US', {
      maximumFractionDigits: 2,
      minimumFractionDigits: 2,
    });
  } else {
    return amount;
  }
}
export function changeApplang(newlang: string, fromlogin = false) {
  localStorage.setItem('emplang', newlang);
  // if (newlang == "ar") {
  //   $('<style id="arabic_style">').load("../themes/ar.css").appendTo("head");
  //   if ($("#ltr_style")) {
  //     $("#ltr_style").remove();
  //   }
  // } else {
  //   if ($("#arabic_style")) $("#arabic_style").remove();
  //   $('<style id="ltr_style">').load("../themes/en.css").appendTo("head");
  // }
  if (!fromlogin) {
    document.documentElement.setAttribute('lang', newlang);
    if ($('body').hasClass(newlang == 'en' ? 'ar' : 'en')) {
      $('body').removeClass(newlang == 'en' ? 'ar' : 'en');
      $('body').addClass(newlang);
    } else if (!$('body').hasClass(newlang)) $('body').addClass(newlang);
    document.documentElement.setAttribute(
      'dir',
      newlang == 'ar' ? 'rtl' : 'ltr',
    );
    document.dir = newlang == 'ar' ? 'rtl' : 'ltr';
  }
}

export function date_Format(date: any, trans: any) {
  // return as 27 Jun, 2022
  let locale: any = localStorage.getItem('emplang');
  if (!locale || locale == '') locale = 'en';
  if (locale == 'en') return moment(date).format('DD MMM, YYYY');
  else {
    const month = moment(date).format('MMMM');

    return (
      moment(date).format('DD') +
      ' ' +
      trans(month) +
      ', ' +
      moment(date).format('YYYY')
    );
  }
}

export function date_Format2(date: any, trans: any) {
  // return as ddd, MMM DD,YYYY
  let locale: any = localStorage.getItem('emplang');
  if (!locale || locale == '') locale = 'en';
  if (locale == 'en') return moment(date).format('ddd, MMM DD, YYYY');
  else {
    const day = moment(date).format('dddd');
    const month = moment(date).format('MMMM');
    return (
      trans(day) +
      ', ' +
      trans(month) +
      ' ' +
      moment(date).format('DD') +
      ', ' +
      moment(date).format('YYYY')
    );
  }
}
export function date_Format3(date: any, trans: any) {
  // return as January - 2023
  let locale: any = localStorage.getItem('emplang');
  if (!locale || locale == '') locale = 'en';
  if (locale == 'en') return moment(date).format('MMMM - YYYY');
  else {
    const month = moment(date).format('MMMM');
    const year = moment(date).format('YYYY');
    return trans(month) + ' - ' + year;
  }
}
export function date_Format4(date: any, trans: any) {
  // return as Feb'2023
  let locale: any = localStorage.getItem('emplang');
  if (!locale || locale == '') locale = 'en';
  if (locale == 'en') return moment(date).format("MMM'YY");
  else {
    const month = moment(date).format('MMMM');
    const year = moment(date).format('YY');
    return trans(month) + "'" + year;
  }
}

export function time_format_for_AM_PM(time: any, trans: any) {
  // return AM | PM in EN & AR
  //DEMO_DATA:
  //8:30 =>  am
  //17:30 => pm
  let locale: any = localStorage.getItem('emplang');
  if (!locale || locale == '') locale = 'en';
  if (locale == 'en') {
    return (
      moment(time, ['HH.mm:ss']).format('hh:mm') +
      ' ' +
      moment(time, ['HH.mm:ss']).format('a')
    );
  } else {
    const day: any = moment(time, ['HH.mm:ss']).format('a');
    return moment(time, ['HH.mm']).format('hh:mm') + ' ' + trans(day);
  }
}

export function time_format_for_AM_PM2(time: any, trans: any) {
  // return AM | PM in EN & AR
  //DEMO_DATA:
  //8:30 =>  am
  //17:30 => pm
  let locale: any = localStorage.getItem('emplang');
  if (!locale || locale == '') locale = 'en';
  if (locale == 'en') {
    return (
      moment(time, ['HH.mm:a']).format('hh:mm') +
      ' ' +
      moment(time, ['HH.mm:a']).format('a')
    );
  } else {
    const day: any = moment(time, ['HH.mm:a']).format('a');
    return moment(time, ['HH.mm']).format('hh:mm') + ' ' + trans(day);
  }
}

export function time_format_for_AM_PM3(time: any, trans: any) {
  let locale: any = localStorage.getItem('emplang');
  if (!locale || locale == '') locale = 'en';
  if (locale == 'en') {
    return moment(time).format('HH:MM a');
  } else {
    const day: any = moment(time).format('a');
    return moment(time).format('hh:mm') + ' ' + trans(day);
  }
}

export const getUtcOffsetHours = (timeZone: string) => {
  const now = new Date();

  if (timeZone == null || timeZone == undefined)  return undefined;
  // 1) Convert the **same instant** into the target zone and into UTC
  const inTarget: any = new Date(now.toLocaleString('en-US', { timeZone }));
  const inUtc: any = new Date(now.toLocaleString('en-US', { timeZone: 'UTC' }));

  // 2) Difference (ms ➜ minutes ➜ hours)
  const offsetMinutes = (inTarget - inUtc) / 60000;
  return offsetMinutes;
};

export function check_user_permission(
  auth_permissions: any,
  status: any,
  type: string,
) {
  let permission_list: any[] = [];
  const permission_items: any[] = [];
  if (auth_permissions && auth_permissions?.length > 0) {
    auth_permissions.forEach((e: any) => {
      if (e?.role) {
        if (
          e?.role?.role_has_permissions &&
          e?.role?.role_has_permissions?.length > 0
        ) {
          permission_list = permission_list.concat(
            e?.role?.role_has_permissions,
          );
        }
      }
    });
  }
  if (permission_list && permission_list?.length > 0) {
    permission_list.forEach((e: any) => {
      const itemexist =
        permission_items?.length == 0
          ? -1
          : permission_items?.findIndex((item) => item?.id == e?.permission_id);
      if (itemexist < 0) permission_items.push(e?.permission);
    });
  }

  // employee list icon handling with permissions
  const admin_list = permission_items?.filter(
    (e) => e?.name == 'Employee Data Admin Access',
  );
  const read_only_list = permission_items?.filter(
    (e) => e?.name == 'Employee Data Read Only Access',
  );
  const restriction_list = permission_items?.filter(
    (e) => e?.name == 'Employee data restriction (edit) Access',
  );
  switch (type) {
    case 'edit':
      if (admin_list?.length > 0) return status;
      else if (read_only_list?.length > 0) return false;
      else if (restriction_list?.length > 0) return false;
      else return status;
    case 'add':
      if (admin_list?.length > 0) return status;
      else if (read_only_list?.length > 0) return false;
      else return status;
    case 'action_menu':
      if (admin_list?.length > 0) return status;
      else if (read_only_list?.length > 0)
        return status?.filter((item: any) => item.field !== 'action');
      else if (restriction_list?.length > 0)
        return status?.filter((item: any) => item.field !== 'action');
      else return status;
    case 'main_menu':
      if (admin_list?.length > 0) return status;
      else if (read_only_list?.length > 0)
        return status?.filter((item: any) => item.name !== 'Off-Boarding');
      else return status;
  }
}
